import { memo as h, useMemo as l, useCallback as s } from "react";
import { Matrix4 as p } from "three";
import { useRefPersistent as x } from "../../hooks/index7.js";
import { MatrixToPosition as m } from "../../utils/index20.js";
import { DotFC as P } from "../dot-fc/index.js";
import { TransformListEditor as E } from "../transform-list-editor/index.js";
import { jsx as f } from "react/jsx-runtime";
const w = h(function({
  points: r,
  renderOrder: a,
  opacity: d,
  radius: c = 10,
  color: u = "#ff0000",
  ...t
}) {
  const C = l(() => r.map((o) => new p().setPosition(o)), [r]), e = x(t), A = s((o, n) => {
    const {
      onChange: i
    } = e();
    !i || i(o, m(n));
  }, []), g = s((o) => {
    const {
      onAdd: n
    } = e();
    !n || n(m(o));
  }, []);
  return /* @__PURE__ */ f(
    E,
    {
      ...t,
      Component: /* @__PURE__ */ f(P, {
        renderOrder: a,
        opacity: d,
        radius: c,
        color: u
      }),
      list: C,
      activeAxes: [!0, !1, !0],
      disableRotations: !0,
      onChange: t.onChange && A,
      onAdd: t.onAdd && g
    }
  );
});
export {
  w as PointListEditor
};
//# sourceMappingURL=index2.js.map
